export default __webpack_public_path__ + "static/media/d33.f4661490.png";